export default __webpack_public_path__ + "static/universlt-light-1f1957c5e65255e86d02f01dceccc970.woff2";